// extracted by mini-css-extract-plugin
module.exports = {"main":"alert_main__LUVPC","body":"alert_body__gPiHM","title":"alert_title__ChOjl","content":"alert_content__S_ECG"};